import {
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
} from "date-fns";

/**
 * Get date range based on filter type
 * @param {string} filterType - One of: "today", "week", "month", "year", "custom"
 * @param {Object|null} customDateRange - Custom date range object with `from` and `to` Date properties
 * @returns {Object} Object with `startDate` and `endDate` Date properties
 */
export function getDateRange(filterType, customDateRange = null) {
  const now = new Date();

  switch (filterType) {
    case "today":
      return {
        startDate: startOfDay(now),
        endDate: endOfDay(now),
      };

    case "week":
      return {
        startDate: startOfWeek(now, { weekStartsOn: 1 }), // Monday
        endDate: endOfWeek(now, { weekStartsOn: 1 }),
      };

    case "month":
      return {
        startDate: startOfMonth(now),
        endDate: endOfMonth(now),
      };

    case "year":
      return {
        startDate: startOfYear(now),
        endDate: endOfYear(now),
      };

    case "custom":
      if (customDateRange && customDateRange.from && customDateRange.to) {
        return {
          startDate: startOfDay(customDateRange.from),
          endDate: endOfDay(customDateRange.to),
        };
      }

      // A single selected custom date should filter that exact day.
      if (customDateRange?.from) {
        return {
          startDate: startOfDay(customDateRange.from),
          endDate: endOfDay(customDateRange.from),
        };
      }

      if (customDateRange?.to) {
        return {
          startDate: startOfDay(customDateRange.to),
          endDate: endOfDay(customDateRange.to),
        };
      }

      // Fallback to today only when no custom date has been selected at all.
      return {
        startDate: startOfDay(now),
        endDate: endOfDay(now),
      };

    default:
      // Default to today
      return {
        startDate: startOfDay(now),
        endDate: endOfDay(now),
      };
  }
}

/**
 * Check if a date is within the given date range
 * @param {Date} date - Date to check
 * @param {Date} startDate - Start of range
 * @param {Date} endDate - End of range
 * @returns {boolean}
 */
export function isDateInRange(date, startDate, endDate) {
  if (!date) return false;
  const dateToCheck = new Date(date);
  return dateToCheck >= startDate && dateToCheck <= endDate;
}

/**
 * Filter transactions by date range
 * @param {Array} transactions - Array of transaction objects
 * @param {Date} startDate - Start date
 * @param {Date} endDate - End date
 * @param {string} dateField - Field name in transaction object that contains the date (default: "created_date")
 * @returns {Array} Filtered transactions
 */
export function filterTransactionsByDateRange(transactions, startDate, endDate, dateField = "created_date") {
  return transactions.filter((tx) => {
    if (!tx[dateField]) return false;
    return isDateInRange(new Date(tx[dateField]), startDate, endDate);
  });
}





